// cart-drawer-ajax-custom.js
// BYB + cart-drawer cross-sell add-to-cart only.
// Do NOT intercept every /cart/add form — UpCart + this script both
// binding the same PDP forms caused qty jumps (1 → 3 per tap).
// ----------------------------------------------------

(function () {
  if (window.BYB_UNIFIED_CART_INIT) {
    return;
  }
  window.BYB_UNIFIED_CART_INIT = true;

  try {
    if (
      window.fetch &&
      typeof window.fetch === "function" &&
      window.fetch.toString().includes("shop_events_listener")
    ) {
      window.originalFetch = window.fetch;
      window.fetch = window.fetch.bind(window);
    }
  } catch (e) {
    console.warn("BYB: Failed to neutralize fetch override", e);
  }

  const nativeFetch = window.originalFetch || window.fetch.bind(window);
  const inflightForms = new WeakSet();
  let crossSellInflight = false;

  const BYB_FORM_SELECTOR = [
    ".coba-duo-step-card form[action*='/cart/add']",
    ".coba-step-card form[action*='/cart/add']",
    ".coba-triple-step-card form[action*='/cart/add']",
  ].join(", ");

  function isBybForm(form) {
    return form instanceof HTMLFormElement && form.matches(BYB_FORM_SELECTOR);
  }

  async function refreshDrawerInner() {
    try {
      if (!customElements.get("drawer-inner")) {
        await customElements.whenDefined("drawer-inner");
      }
    } catch (e) {}

    const drawerInner = document.querySelector("cart-drawer drawer-inner");
    if (drawerInner && typeof drawerInner.requestRender === "function") {
      await drawerInner.requestRender();
      return true;
    }
    return false;
  }

  async function dispatchCartChanged() {
    try {
      const cartRes = await nativeFetch("/cart.js");
      if (!cartRes.ok) return;

      const cartData = await cartRes.json();
      document.dispatchEvent(
        new CustomEvent("cart:changed", {
          detail: { cartData },
          bubbles: true,
        }),
      );
    } catch (error) {
      console.warn("BYB: Failed to dispatch cart:changed", error);
    }
  }

  async function refreshDrawerSection() {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer) return;

    const sectionId = drawer.dataset.sectionId;
    if (!sectionId) return;

    const res = await nativeFetch(`/?sections=${sectionId}`);
    const json = await res.json();
    const drawerHTML = json[sectionId];
    if (!drawerHTML) return;

    const doc = new DOMParser().parseFromString(drawerHTML, "text/html");
    const newDrawer = doc.querySelector("cart-drawer");
    const liveDrawer = document.querySelector("cart-drawer");

    if (newDrawer && liveDrawer) {
      liveDrawer.innerHTML = newDrawer.innerHTML;
      window.dispatchEvent(new Event("fluco:modal:cartDrawer:open"));
    }
  }

  async function refreshCartUI() {
    const ok = await refreshDrawerInner();
    if (!ok) await refreshDrawerSection();
  }

  async function handleBybFormSubmit(event) {
    const form = event.target;
    if (!isBybForm(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (inflightForms.has(form) || form.dataset.bybSubmitting === "true") {
      return;
    }

    inflightForms.add(form);
    form.dataset.bybSubmitting = "true";

    const variantId = new FormData(form).get("id");
    const submitBtn = form.querySelector('[type="submit"], button:not([type])');
    if (submitBtn) submitBtn.disabled = true;

    try {
      if (!variantId) return;

      const resp = await nativeFetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
        }),
      });

      if (!resp.ok) return;

      await dispatchCartChanged();
      window.dispatchEvent(new Event("fluco:modal:cartDrawer:open"));
      await refreshCartUI();
    } finally {
      inflightForms.delete(form);
      delete form.dataset.bybSubmitting;
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  document.addEventListener("submit", handleBybFormSubmit, true);

  document.addEventListener("click", async (event) => {
    const btn = event.target.closest(".cross-sells-item__add-button");
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    if (crossSellInflight || btn.disabled || btn.dataset.loading === "true") {
      return;
    }

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    crossSellInflight = true;
    btn.dataset.loading = "true";
    btn.disabled = true;

    try {
      const resp = await nativeFetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
        }),
      });

      if (!resp.ok) return;

      await dispatchCartChanged();
      window.dispatchEvent(new Event("fluco:modal:cartDrawer:open"));
      await refreshCartUI();
    } finally {
      crossSellInflight = false;
      btn.dataset.loading = "false";
      btn.disabled = false;
    }
  });
})();
